import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6be8bd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "navigation__menu" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.bearz.tech/",
  target: "_blank",
  class: "nav-link"
}, "BearzVerse", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://cyberbearz.medium.com/",
  target: "_blank",
  class: "nav-link"
}, "Medium", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://twitter.com/cyberbearz",
  target: "_blank",
  class: "nav-link"
}, "TW", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://t.me/cyberbearzz",
  target: "_blank",
  class: "nav-link"
}, "TG", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://discord.gg/bt2RC38a4e",
  target: "_blank",
  class: "nav-link"
}, "Discord", -1))
const _hoisted_9 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "accordion",
      onEnter: _ctx.start,
      onAfterEnter: _ctx.end,
      onBeforeEnter: _ctx.beforeEnter,
      onBeforeLeave: _ctx.start,
      onAfterLeave: _ctx.end
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                (_ctx.activePageMyArmy === false)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      href: "#",
                      class: "primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.connectWallet()))
                    }, " Connect "))
                  : _createCommentVNode("", true),
                (_ctx.activePageMyArmy === true)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({name: 'Army'}))),
                      class: "button secondary"
                    }, " My Army "))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.isOpen]
        ])
      ]),
      _: 1
    }, 8, ["onEnter", "onAfterEnter", "onBeforeEnter", "onBeforeLeave", "onAfterLeave"])
  ]))
}